import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { PaginationModule } from 'app/shared/components/pagination/pagination.module';
import { ScrollViewModule } from 'app/shared/components/scroll-view/scroll-view.module';
import { SelectBoxModule } from 'app/shared/components/select-box/select-box.module';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { ResultsStatisticsViewComponent } from './results-statistics-view.component';

@NgModule({
  imports: [
    CommonModule,
    MatTableModule,
    PaginationModule,
    SelectBoxModule,
    ScrollViewModule,
    BlockModalDragModule,
  ],
  declarations: [ResultsStatisticsViewComponent],
  exports: [ResultsStatisticsViewComponent],
})
export class ResultsStatisticsViewModule {}
